
import { useEffect } from 'react'
import Select from 'react-select'
import { DepartmentDDLAPI, SectorDDLAPI, WardNameDDLAPI, YesNoDDLAPI } from '../../Redux/DDLSlice'
import { useDispatch, useSelector } from 'react-redux'
import { useAuthState } from '../../Helper/Context'

export const YesNoDataDDL = (props) => {
    const { GetPresent, setGetPresent, CropNameDashboardData, PopUpField, DDLHeading, rowData, Flag } = props

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch()

    useEffect(() => {
        const data = { UserID, token }
        dispatch(YesNoDDLAPI({ data }))
    }, [])

    const { YesNoData } = useSelector(state => state.YesNoDDLData)

    useEffect(() => {
        handleYesNoDDL()
    }, [YesNoData])

    const handleYesNoDDL = () => {
        // console.log(DeptDDLDataa)
        if (YesNoData && YesNoData.table && YesNoData.table.length > 0) {
            let list = YesNoData.table.map((item, index) => ({
                value: item.yesNoIndicatorID,
                label: item.yesNoIndicator,
            }))

            if (DDLHeading == 'Get Present') {
                setGetPresent({
                    DDL: list,
                    ID: Flag === 'Update' ? rowData.isGetPresent : 0,
                    Label: Flag === 'Update' ? rowData.isGetPresentName : "Select...",
                })
            }else if (DDLHeading == 'Watering of Edges Present') {
                setGetPresent({
                    DDL: list,
                    ID: Flag === 'Update' ? rowData.isWateringOfEdgesPresent : 0,
                    Label: Flag === 'Update' ? rowData.isWateringOfEdgesPresentName : "Select...",
                })
            }else if (DDLHeading == 'Watering of Tree Present') {
                setGetPresent({
                    DDL: list,
                    ID: Flag === 'Update' ? rowData.isWateringOfTreesPresent : 0,
                    Label: Flag === 'Update' ? rowData.isWateringOfTreesPresentName : "Select...",
                })
            }else{
                setGetPresent({
                    DDL: list,
                    ID: Flag === 'Update' ? rowData.isWateringOfLawnsPresent : 0,
                    Label: Flag === 'Update' ? rowData.isWateringOfLawnsPresentName : "Select...",
                })
            }

        }
        else {
            setGetPresent({
                DDL: [],
                ID: 0,
                Label: "Select...",
            })
        }

    }

    return (
        <div className="form-group">
            <label className="d-block" htmlFor="NameofDepartment">{DDLHeading}</label>
            <Select
                isClearable
                // isRtl={isRtl}
                isSearchable
                maxMenuHeight={150}
                value={{ value: GetPresent.ID, label: GetPresent.Label }}
                onChange={(e) => {
                    e ?
                        setGetPresent({ ...GetPresent, ID: e.value, Label: e.label })
                        :
                        setGetPresent({ ...GetPresent, ID: 0, Label: "Select..." })

                }}
                options={GetPresent.DDL}
            />
        </div>
    )
}